import { Injectable } from '@angular/core';

@Injectable()
export class InfoUtil {
  static cdAgencia: any;
  static parametros: any[] = [];
  static _sysdate: Date = new Date();
  static tokenAccess: string = null;
  static userName: string = null;

  static get sysdate(): Date {
    const local = new Date();
    const userTimezone = 3 * 60*60*1000;
    const banco = new Date((local.getUTCMilliseconds() + userTimezone));
    return banco;
  }
}



// WEBPACK FOOTER //
// ./src/app/core/info-util.ts